import * as actionTypes from "../types/layout";

export const setSidebarCollapse = (
  isSidebarCollapsed: boolean
): actionTypes.SetSidebarCollapse => ({
  type: actionTypes.SET_SIDEBAR_COLLAPSE,
  isSidebarCollapsed,
});
